import { create } from "zustand";
import { getIncenctivesWeightageAndTargetDashboardFilterData, getIncenctivesWeightageAndTargetDashboard, editWeightageAndTargetDBdata } from "../api";
import { toast } from "react-toastify";

export const useWeightageAndTarget = create((set) => ({
  weightageAndTargetData: { 
    headers: [],
    total_row_count: 0,
    page_number: 0,
    page_size: 0,
    view_type: "",
    is_downloadable: false,
    rows_data: [],
    others: {}
   },
  weightageAndTargetDataLoading: false,
  weightageAndTargetDataError: null,
  weightageAndTargetFilterData: [],
  weightageAndTargetFilterDataLoading: false,
  weightageAndTargetFilterDataError: null,
  fetchWeightageAndTargetFilters: async () => {
    try {
      set({
        weightageAndTargetFilterDataLoading: true,
        weightageAndTargetFilterDataError: null,
      });
      const response = await getIncenctivesWeightageAndTargetDashboardFilterData();
      set({ weightageAndTargetFilterData: response.data });
    } catch (error) {
      set({ weightageAndTargetFilterDataError: error.message });
      toast.error(error.message);
    } finally {
      set({ weightageAndTargetFilterDataLoading: false });
    }
  },
  fetchWeightageAndTargetData: async(params) => {
    try {
      set({
        weightageAndTargetDataLoading: true,
        weightageAndTargetDataError: null,
      });
      const response = await getIncenctivesWeightageAndTargetDashboard(params);
      set({ weightageAndTargetData: response.data });
    } catch (error) {
      set({ weightageAndTargetDataError: error.message });
      toast.error(error.message);
    } finally {
      set({ weightageAndTargetDataLoading: false });
    }
  },
  fetchEditWeightageAndTargetData: async (payload,params) => {
    try {
      set({ weightageAndTargetDataLoading: true, weightageAndTargetDataError: null });
      await editWeightageAndTargetDBdata(payload);
      toast.success("Updated Successfully");
    } catch (error) {
      set({ weightageAndTargetDataError: error.message });
      toast.error( error?.response?.data?.message);
    } finally {
      set({ weightageAndTargetDataLoading: false });
    }
  },



}));
